import { Component, OnInit } from '@angular/core';
import { LicenseStatusBarState } from './license-status-bar.state';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LicenseSuspendedModalComponent } from '../license-suspended-modal/license-suspended-modal.component';
import { BillingManager } from '../../managers/billing.manager';
import { OrganizationLicenseStatusEnum } from '../../enums/organization-license-status.enum';

@Component({
  selector: 'app-license-status-bar',
  templateUrl: './license-status-bar.component.html',
  styleUrls: ['./license-status-bar.component.scss'],
  standalone: false,
})
export class LicenseStatusBarComponent implements OnInit {
  state: LicenseStatusBarState = LicenseStatusBarState.Active; // We assume active in the UI to not show anything until we have confirmations

  freeTrialDaysLeft = 0;

  constructor(private readonly billingManager: BillingManager,
              public modalService: NgbModal) {
  }

  async ngOnInit() {
    const licenseStatusEnum = await this.billingManager.getLicenseStatus();

    switch (licenseStatusEnum) {
      case OrganizationLicenseStatusEnum.Suspended:
        this.state = LicenseStatusBarState.Suspended;
        break;

      case OrganizationLicenseStatusEnum.TrialEnded:
        this.state = LicenseStatusBarState.FreeTrialOver;
        break;

      case OrganizationLicenseStatusEnum.Trialing:
        this.freeTrialDaysLeft = await this.billingManager.getNumberOfDaysLeft();

        // We give a 3 days grace period.
        if (this.freeTrialDaysLeft <= -3) {
          this.freeTrialDaysLeft = 0;
          this.state = LicenseStatusBarState.Suspended;
          const hasBeenShownAlready = window.sessionStorage.getItem('license-expired-modal-shown');
          if (hasBeenShownAlready !== null) {
            break;
          }

          const modal = this.modalService.open(LicenseSuspendedModalComponent);
          modal.closed.subscribe(async result => {
            window.sessionStorage.setItem('license-expired-modal-shown', 'true');
          });
        }

        if (this.freeTrialDaysLeft <= 3) {
          this.state = LicenseStatusBarState.FreeTrialLessThan3DaysLeft;
          break;
        }


        if (this.freeTrialDaysLeft <= 7) {
          this.state = LicenseStatusBarState.FreeTrialLessThan7DaysLeft;
          break;
        }

        this.state = LicenseStatusBarState.FreeTrial;
        break;

      case OrganizationLicenseStatusEnum.Active: {
        const numberOfDaysBeforeCancellation = await this.billingManager.getNumberOfDaysLeft();

        if (numberOfDaysBeforeCancellation <= 0) {
          this.state = LicenseStatusBarState.Suspended;
          const hasBeenShownAlready = window.sessionStorage.getItem('license-expired-modal-shown');
          if (hasBeenShownAlready !== null) {
            break;
          }

          const modal = this.modalService.open(LicenseSuspendedModalComponent);
          modal.closed.subscribe(async result => {
            window.sessionStorage.setItem('license-expired-modal-shown', 'true');
          });
        }

        if (numberOfDaysBeforeCancellation <= 3) {
          this.state = LicenseStatusBarState.LessThan3DaysLeft;
          break;
        }

        if (numberOfDaysBeforeCancellation <= 7) {
          this.state = LicenseStatusBarState.LessThan7DaysLeft;
          break;
        }

        this.state = LicenseStatusBarState.Active;
        break;
      }
    }
  }

  getClass() {

    switch (this.state) {
      case LicenseStatusBarState.Suspended:
      case LicenseStatusBarState.None:
      case LicenseStatusBarState.LessThan3DaysLeft:
      case LicenseStatusBarState.FreeTrialLessThan3DaysLeft:
      case LicenseStatusBarState.FreeTrialOver:
        return 'bg-danger text-white ';


      case LicenseStatusBarState.LessThan7DaysLeft:
      case LicenseStatusBarState.FreeTrialLessThan7DaysLeft:
        return 'bg-warning text-dark';

      case LicenseStatusBarState.FreeTrial:
        return 'bg-primary text-white';

      case LicenseStatusBarState.Active:
        return '';
    }
  }
}